import { useEffect, useState } from "react";
import { Button } from "../../../components/buttons/button";
import { ContainerCard } from "../../../components/cards/containerCard";
import { FromThriftCorpSign } from "../../../components/typography/fromThriftCorpSign";
import { PageTitle } from "../../../components/typography/pageTitle";
import { useLayout } from "../../../customHooks/useLayout";
import { isProfileApproved } from "../../../helperFunctions";
import { useAppSelector } from "../../../redux/hooks";

export const IncompleteProfile = () => {
  const [greetingText, setGreetingText] = useState<string>();
  const [greetingEmoji, setGreetingEmoji] = useState<string>();
  const [name, setName] = useState<string>();

  const { profile, onboardingCompletionStatus } = useAppSelector((state) => {
    return state.auth;
  });

  const { setPopupOpen } = useLayout();

  useEffect(() => {
    let today = new Date();
    let curHr = today.getHours();

    if (curHr < 12) {
      setGreetingText("morning");
      setGreetingEmoji("⛅️");
    } else if (curHr < 18) {
      setGreetingText("afternoon");
      setGreetingEmoji("🌤️");
    } else {
      setGreetingText("evening");
      setGreetingEmoji("🌙");
    }

    profile?.type === "member"
      ? setName(profile?.FirstName)
      : setName(profile?.CoopName);
  }, [profile]);

  return (
    <>
      {/* Greeting */}
      <PageTitle
        text={`Good ${greetingText}, ${name} ${greetingEmoji}`}
        className="capitalize hidden md:block"
      />

      {/* Large card */}
      <div
        className="
        w-full md:mt-6 bg-white border border-border-grey
        rounded-lg flex items-center overflow-hidden xl:h-[304px] gap-[64px]
        "
      >
        <div
          className="
          text-pry-dark-green-100 text-[18px] lg:text-[32px]
          font-bold px-[20px] py-[32px] lg:px-8 lg:py-12 xl:pr-0 xl:py-0
          leading-normal lg:leading-10 xl:w-5/12 tracking-none
          "
        >
          {isProfileApproved(profile) ? (
            <>
              <p className="w-full">
                Complete your onboarding checklist to get the full ThriftCorp
                experience.
              </p>

              <Button
                text="View Checklist"
                onClick={() => {
                  !onboardingCompletionStatus?.isAllComplete &&
                    setPopupOpen(true);
                }}
                type="button"
                className="max-w-[150px] lg:max-w-[180px] mt-[24px] lg:mt-10 md:!py-3 !text-sm lg:!text-base"
                loading={false}
                disabled={false}
                variation="primary"
              />
            </>
          ) : (
            <>
              <p
                className="
                bg-warning-yellow-bg-50 text-orange-100 w-fit
                px-5 py-3 rounded-[120px] text-base md:text-xl 
                "
              >
                We are reviewing your account
              </p>

              <p
                className="
                !text-pry-dark-green-300/80 mt-6 md:mt-4
                text:lg md:text-xl leading-normal md:!leading-[28px] !font-medium
                "
              >
                This usually takes 1-2 business days. Once approved, you’ll gain
                access to more features. We'll notify you via email with the
                next steps. Thank you for your patience!
              </p>

              <FromThriftCorpSign className="!mt-8 md:!mt-[34px]" />
            </>
          )}
        </div>

        <div className={`hidden xl:block flex-1 h-full`}>
          {isProfileApproved(profile) ? (
            <img
              src="/assets/images/welcome_vector.svg"
              alt="welcome"
              className="block h-full w-full object-cover"
            />
          ) : (
            <img
              src="/assets/images/welcome_vector.svg"
              alt="welcome"
              className="block w-full h-full object-cover"
            />
          )}
        </div>
      </div>

      {isProfileApproved(profile) && (
        <div
          className="
          w-full mt-6
          grid grid-cols-1 xl:grid-cols-2 gap-6
          overflow-hidden text-sm lg:text-base
          "
        >
          <ContainerCard>
            <p className="font-medium">Hey {name}!</p>

            <p className="mt-4 text-pry-lighter-green-100">
              Make sure you complete your onboarding as soon as possible to
              ensure that you’re ready to start{" "}
              {profile?.type === "cooperative"
                ? " registering members to your cooperative "
                : " managing your cooperatives "}
              with ThriftCorp.
              <br />
              <br /> If you have any issues or concerns, please reach us via any
              of our support channels.
            </p>

            <FromThriftCorpSign />
          </ContainerCard>
        </div>
      )}
    </>
  );
};
